var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.813 11.3551L12.1604 9.30174C12.0322 9.20288 11.8725 9.1541 11.711 9.16453C11.5495 9.17496 11.3974 9.24389 11.283 9.35841L9.87502 10.7671C9.77015 10.873 9.63259 10.9405 9.48462 10.9585C9.33665 10.9765 9.18693 10.9441 9.05969 10.8664C8.60636 10.5884 7.84769 10.0497 6.89836 9.09974C5.94902 8.15108 5.41036 7.39174 5.13236 6.93908C5.0546 6.81194 5.02216 6.66223 5.04032 6.51431C5.05847 6.36639 5.12616 6.22897 5.23236 6.12441L6.64036 4.71574C6.75504 4.60147 6.82403 4.44924 6.83434 4.28767C6.84465 4.12611 6.79558 3.96634 6.69636 3.83841L4.64369 1.18508C4.17702 0.583079 3.29702 0.487745 2.72369 0.991079C1.96836 1.65375 1.06102 2.64641 0.797022 3.76041C0.319022 5.76708 1.07436 8.28508 4.39436 11.6051C7.71436 14.9244 10.2324 15.6804 12.2384 15.2031C13.3524 14.9377 14.3457 14.0297 15.0084 13.2751C15.511 12.7017 15.4157 11.8217 14.813 11.3551Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.37058c66cd571939a1ef24612b9c88c7.svg";
export { ForwardRef as ReactComponent };